// extracted by mini-css-extract-plugin
module.exports = {"alertsContainer":"style_alertsContainer__1Wsg4","alert":"style_alert__1OkIS"};